import { useRef } from "react";
import { SlotsToClasses } from "@nextui-org/react";
import { cn } from "@/libs/utils/tailwind/cn";
import Carousel, { SwiperSlide } from "@/components/ui/Carousel";
import ArrowLeftIcon from "@/components/ui/Carousel/assets/ArrowLeftIcon";
import ArrowRightIcon from "@/components/ui/Carousel/assets/ArrowRightIcon";
import ReviewCard from "./ReviewCard";
import { REVIEWS } from "../../constants/reviews";

export default function ReviewsSection({
  className,
  classNames,
}: ReviewsSectionProps) {
  const prevRef = useRef<HTMLButtonElement>(null);
  const nextRef = useRef<HTMLButtonElement>(null);
  const paginationRef = useRef<HTMLDivElement>(null);

  return (
    <section
      className={cn("w-full py-16", classNames?.base, className)}
    >
      <h2 className="mb-6 sm:mb-8 text-center text-base sm:text-[26px] font-semibold tracking-tight">
        Homeowner Reviews
      </h2>

      <Carousel
        slidesPerView={1}
        spaceBetween={0}
        showArrows={false}
        showDots={false}
        noSafePadding
        navigationPrevRef={prevRef}
        navigationNextRef={nextRef}
        paginationRef={paginationRef}
        className="w-full"
      >
        {REVIEWS.map((review, index) => (
          <SwiperSlide key={index}>
            <ReviewCard review={review} />
          </SwiperSlide>
        ))}
      </Carousel>

      <div className="mt-1 sm:mt-12 flex items-center justify-center gap-6">
        <button
          ref={prevRef}
          className="flex size-12 items-center justify-center rounded-2xl border border-default-200 bg-white text-foreground shadow-sm transition-opacity hover:opacity-80 disabled:opacity-30"
          aria-label="Previous review"
        >
          <ArrowLeftIcon className="size-5" />
        </button>

        <div
          ref={paginationRef}
          className="flex max-w-fit items-center justify-center gap-5 mx-2 [&_.swiper-pagination-bullet]:relative [&_.swiper-pagination-bullet]:size-1.5 [&_.swiper-pagination-bullet]:rounded-full [&_.swiper-pagination-bullet]:bg-default-400 [&_.swiper-pagination-bullet]:opacity-50 [&_.swiper-pagination-bullet]:after:absolute [&_.swiper-pagination-bullet]:after:inset-[-8px] [&_.swiper-pagination-bullet]:after:content-[''] [&_.swiper-pagination-bullet-active]:!bg-foreground [&_.swiper-pagination-bullet-active]:!opacity-100"
        />

        <button
          ref={nextRef}
          className="flex size-12 items-center justify-center rounded-2xl border border-default-200 bg-white text-foreground shadow-sm transition-opacity hover:opacity-80 disabled:opacity-30"
          aria-label="Next review"
        >
          <ArrowRightIcon className="size-5" strokeWidth={2} />
        </button>
      </div>
    </section>
  );
}

interface ReviewsSectionProps {
  className?: string;
  classNames?: SlotsToClasses<"base" | "container">;
}
